import { render } from "./SingleQuestion.vue?vue&type=template&id=79185f94&scoped=true&ts=true"
import script from "./SingleQuestion.vue?vue&type=script&lang=ts"
export * from "./SingleQuestion.vue?vue&type=script&lang=ts"

import "./SingleQuestion.vue?vue&type=style&index=0&id=79185f94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79185f94"]])

export default __exports__